export default {"src":"/_next/static/media/phone-yellow.1051eaa4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};